import { Flex } from "@chakra-ui/layout";
import { Modal } from "antd";
import FormArrecadacao from "./FormArrecadacao";

interface ModalFormArrecadacaoProps {
  isOpen: boolean;
  onClose: () => any;
  idArrecadacao?: string;
  year: string;
  month: string;
  onSave?: () => any;
}

function ModalFormArrecadacao({
  isOpen,
  onClose,
  idArrecadacao,
  year,
  month,
  onSave,
}: ModalFormArrecadacaoProps) {
  return (
    <Modal
      visible={isOpen}
      footer={null}
      onCancel={onClose}
      destroyOnClose
      width="700px"
      bodyStyle={{
        overflow: "auto",
        paddingBottom: 16,
      }}
    >
      <Flex pt={6} rounded={16} h="100%">
        <FormArrecadacao
          idArrecadacao={idArrecadacao}
          year={year}
          month={month}
          onClose={() => {
            onClose();
            onSave?.();
          }}
        />
      </Flex>
    </Modal>
  );
}

export default ModalFormArrecadacao;
